// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1pOTU","load2":"Spinner_load2__1r4Lz"};